export default __webpack_public_path__ + "static/home3-4710baa072cd4aea6c379b01fd95b289.jpeg";